import { type FunctionComponent } from "react"

import type { WithContentfulHeaderLocationFragment } from "~/contentful"
import Link from "~/components/Link"
import { contentfulImageUrl } from "~/helpers/contentful"
import classNames from "classnames"
import {
  getLocationCardHeadline,
  getLocationCardSubline,
  resolveLocationRouteSlug
} from "~/helpers/location"

const HeaderLocationsPopover: FunctionComponent<{
  locationPages: WithContentfulHeaderLocationFragment[]
  closePopover: () => void
  onSelectLocation?: (locationName: string) => string | null
}> = ({ locationPages, closePopover, onSelectLocation }) => {
  const handleClick = () => closePopover()

  return (
    <div className="w-screen max-w-camp-container-limit">
      <div className="grid grid-cols-3 gap-x-12 gap-y-8 px-16 pt-8 pb-8 lg:grid-cols-5">
        {locationPages.map(locationPage => {
          const headline = getLocationCardHeadline(locationPage.name)
          const subline = getLocationCardSubline(
            locationPage.name,
            locationPage.city
          )

          return (
            <Link
              key={locationPage.sys.id}
              className="flex flex-col items-center justify-end gap-2 text-camp-primary"
              to={
                (onSelectLocation && locationPage.name
                  ? onSelectLocation(locationPage.name)
                  : null) ??
                (locationPage.slug
                  ? `/${resolveLocationRouteSlug(locationPage.slug)}`
                  : null)
              }
              handleClick={handleClick}
            >
              {locationPage.logo?.url && (
                <img
                  loading="lazy"
                  src={contentfulImageUrl(locationPage.logo.url, {
                    width: 280,
                    height: 200
                  })}
                  alt=""
                  className=""
                  width={140}
                  height={100}
                />
              )}
              <div className="text-green-dark text-center font-serif text-lg">
                <div>{headline}</div>

                {locationPage?.slug && subline && (
                  <small
                    className={classNames(
                      "text-center font-serif text-sm opacity-60",
                      { uppercase: subline.uppercase }
                    )}
                  >
                    {subline.text}
                  </small>
                )}
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default HeaderLocationsPopover
